module.exports = __webpack_public_path__ + "media/images/adele-a20e1fa9c2917992c5d91de3fa4d4d97.jpg";